import { render, staticRenderFns } from "./ActiveFilters.vue?vue&type=template&id=5a2d563a&scoped=true"
import script from "./ActiveFilters.vue?vue&type=script&lang=ts"
export * from "./ActiveFilters.vue?vue&type=script&lang=ts"
import style0 from "./ActiveFilters.vue?vue&type=style&index=0&id=5a2d563a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2d563a",
  null
  
)

export default component.exports